module.exports = __webpack_public_path__ + "static/media/groupdp.8e5d6ab4.png";